<template>
  <div class="hello">
    <div class="top clearfix">
      <div class="top-title lft"></div>
      <!-- <div class="top-search rgt">
        <el-tabs v-model="activeName">
          <el-tab-pane label="众信验证查询" name="first">
            <form action="https://yz.ebs.org.cn/Archives/PreSearch.html" method="post">
              <input
                type="text"
                class="search-ipt"
                name="nameOrWeb"
                placeholder="请输入你要查询的企业全称或网站名称"
              />
              <input type="submit" class="search-btn" value="查询" />
            </form>
          </el-tab-pane>
          <el-tab-pane label="国际诚信认证查询" name="second">
            <form action="https://www.globaletrust.com/Certificate/VerArchivesInfo" method="get">
              <input
                type="text"
                class="search-ipt"
                name="searchText"
                placeholder="请输入你要查询的企业全称或网站名称"
              />
              <input type="submit" class="search-btn" value="查询" />
            </form>
          </el-tab-pane>
        </el-tabs>
      </div> -->
    </div>
    <!-- 导航 -->
    <div class="menu">
      <el-menu :default-active="activeIndex" mode="horizontal" @select="handleSelect" class="menu-list">
        <el-menu-item index="/">首页</el-menu-item>
        <el-menu-item :index="`/InstitutionalDynamics/${this.type}`">机构动态</el-menu-item>
        <!-- <el-menu-item index="https://zxj.ebs.org.cn/">智信+平台服务</el-menu-item> -->
        <el-submenu index="1">
          <template slot="title">数字贸易和产业促进服务</template>
          <el-menu-item index="https://www.pinxintong.com/">品信通质量防伪溯源服务</el-menu-item>
          <!-- <el-menu-item index="https://www.globalodr.com/">在线纠纷解决（ODR）服务</el-menu-item> -->
          <el-menu-item index="https://www.ebsip.com/">知识产权保护与促进服务</el-menu-item>
        </el-submenu>
        <el-submenu index="2">
          <template slot="title">公共服务</template>
          <!-- <el-menu-item index="https://sz.ebs.org.cn/">深圳电子商务服务监管网</el-menu-item> -->
          <el-menu-item index="https://kj.ebs.org.cn/home">深圳市跨境电子商务交易保障支撑服务系统</el-menu-item>
        </el-submenu>
        <el-menu-item index="/AboutUs">关于我们</el-menu-item>
      </el-menu>
    </div>
  </div>
</template>

<script>
export default {
  name: "Header",
  data() {
    return {
      activeName: "first",
      activeIndex: "/",
      type: 1
    };
  },
  created() {
    this.type =
      this.$route.params && this.$route.params.type
        ? this.$route.params.type
        : 1;
    this.activeIndex = this.$route.path
  },
  methods: {
    handleSelect(key) {
      const reg = /(http:\/\/|https:\/\/)/ig
      
      reg.test(key) ? window.open(key) : this.$router.push({ path: key }).catch(() => {})
    }
  }
};
</script>

<style lang="less" scoped>
.hello {
  position: relative;
  .top {
    width: 1040px;
    height: 120px;
    margin: 0 auto;
    .top-title {
      width: 160px;
      height: 60px;
      margin-top: 30px;
      background: url("../assets/images/Home/bg/title-logo.png") no-repeat;
    }
    .top-search {
      margin-top: 10px;
      /deep/ .el-tabs__header {
        margin-bottom: -4px;
        .el-tabs__active-bar {
          left: 36px;
          height: 6px;
          width: 18px !important;
        }
        .el-tabs__item {
          color: #666;
          &:hover {
            color: #d0211f;
            font-weight: bold;
          }
        }
        .el-tabs__item.is-active {
          color: #333;
          font-weight: 900;
        }
        .el-tabs__active-bar {
          background-color: #d0211f;
        }
        .el-tabs__nav-wrap::after {
          background-color: transparent;
        }
      }
      .search-ipt {
        width: 460px;
        height: 40px;
        border-radius: 4px;
        border: 1px solid #dcdfe6;
        box-sizing: border-box;
        color: #606266;
        display: inline-block;
        padding: 0 15px;
        transition: border-color 0.2s cubic-bezier(0.645, 0.045, 0.355, 1);
      }
      .search-btn {
        color: #fff;
        border-radius: 4px;
        border: 1px solid #dcdfe6;
        cursor: pointer;
        background: #d0211f;
        width: 60px;
        height: 41px;
        margin-left: 5px;
        vertical-align: top;
      }
      .el-form {
        .el-form-item {
          /deep/ .el-input__inner {
            width: 460px;
            height: 40px;
          }
          .el-button {
            background-color: #d0211f;
            border-color: #d0211f;
            padding: 6px;
            /deep/.el-icon-search:before {
              font-size: 25px;
            }
          }
        }
      }
    }
    .banner-img {
      /*设置图片宽度和浏览器宽度一致*/
      width: 100%;
      height: inherit;
    }
  }
  .menu {
    z-index: 10;
    position: absolute;
    top: 120px;
    left: 0;
    right: 0;
    /deep/ .menu-list {
      border: none;
      display: flex;
      justify-content: center;
      background: rgba(0, 0, 0, .5);
      li {
        padding: 0 20px;
        font-size: 16px;
        color: rgba(255, 255, 255, 1);
        .el-submenu__title {
          font-size: 16px;
          color: rgba(255, 255, 255, 1);
          &:hover {
            background: transparent;
          }
          i::before {
            color: rgba(255, 255, 255, 1);
          }
        }
        &:hover {
          background: rgba(0, 0, 0, 1);
        }
        &.is-active {
          background: rgba(0, 0, 0, 1);
          border-bottom: 4px solid #d0211f;
          .el-submenu__title {
            border-bottom: none;
          }
        }
      }
    }
  }
}
</style>
